import claim from '@/api/wholesale/borrowing-spare-part-claim'

import { baseState, baseMutations } from '@/store/mixins'
import {join } from 'lodash'
import moment from 'moment'

export const state = {
  ...baseState,
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: join(context.state.dateRange, ','),
          is_return: context.state.isReturn
        }
      },
      attributes
    )
    return claim.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  updateRef(context, { id, data }) {
    return claim.updateRef(id, data)
  },
}
